<template>
  <div>
    <div class="chart blockcont">
      <div class="row blockcont">
        <div class="col-xs-6">
          <div class="smalltitle">Monthly Chart</div>
          You're viewing data from <strong>Jan 2017</strong> to <strong>Dec 2017</strong>.
        </div>
        <div class="col-xs-6">
          <form class="onelineform statssearch">
            <input type="text" picker="month" placeholder="From" class="testdate" value="01/2017">
            <div class="to"><i class="fa fa-angle-double-right"></i></div>
            <input type="text" picker="month" placeholder="To" class="testdate" value="12/2017">
            <button class="submit btn light"><i class="fa fa-chart-area"></i></button>
          </form>
        </div>
      </div>
      <div class="row blockcont smallmargin">
        <div class="col-xs-3">
          <ul class="itstats">
            <li class="headnote">Performance Chart</li>
            <li>Patients Had Prick Tests<span>188</span></li>
            <li>Patients Had ID Tests<span>188</span></li>
            <li>Vaccine Orders<span>188</span></li>
            <li>Vaccine New Mixes<span>188</span></li>
            <li>Vaccine Refills<span>188</span></li>
            <li>Patients Started on IT<span>188</span></li>
            <li class="light">Active patients on IT<span>188</span></li>
          </ul>
        </div>
        <div class="col-xs-9">
          <canvas id="myChart" width="100%" height="60" class="blockcont"></canvas>
          <canvas id="myChart10" width="100%" height="40" class="blockcont"></canvas>
        </div>
      </div>

      <div class="row blockcont smallmargin">
        <div class="col-xs-3">
          <ul class="itstats">
            <li class="headnote">Productivity Chart</li>
            <li>Number of Pricks<span>188</span></li>
            <li>Number of ID Tests<span>188</span></li>
            <li>Antigen Doses<span>188</span></li>
            <li>IT Visits<span>188</span></li>
            <li>IT Reaction<span>188</span></li>
            <li>Biologic Injections<span>188</span></li>
            <li>Cluster/Rush IT Hours<span>188</span></li>
          </ul>
        </div>
        <div class="col-xs-9">
          <div class="row smallmargin blockcont">
            <div class="col-xs-6">
              <canvas id="myChart2" width="100%" height="60" class="blockcont"></canvas>
            </div>
            <div class="col-xs-6">
              <canvas id="myChart5" width="100%" height="60" class="blockcont"></canvas>
            </div>
            <div class="col-xs-6">
              <canvas id="myChart4" width="100%" height="60" class="blockcont"></canvas>
            </div>
            <div class="col-xs-6">
              <canvas id="myChart3" width="100%" height="60" class="blockcont"></canvas>
            </div>
          </div>
          <canvas id="myChart15" width="100%" height="40" class="blockcont"></canvas>
          <canvas id="myChart16" width="100%" height="40" class="blockcont"></canvas>
        </div>
      </div>
      <div class="row smallmargin">
        <div class="col-xs-3">
          <ul class="itstats">
            <li class="headnote">Utilization of Supplies</li>
            <li>Single pricks<span>188</span></li>
            <li>Multi pricks<span>188</span></li>
            <li>Testing syringes<span>188</span></li>
            <li>Mixing syringes<span>188</span></li>
            <li>Treating syringes<span>188</span></li>
            <li>Antigen (mL)<span>188</span></li>
            <li>Pink vials<span>188</span></li>
            <li>Silver vials<span>188</span></li>
            <li>Green vials<span>188</span></li>
            <li>Blue vials<span>188</span></li>
            <li>Yellow vials<span>188</span></li>
            <li>Red vials<span>188</span></li>
            <li>Diluent (mL)<span>188</span></li>
          </ul>
        </div>
        <div class="col-xs-9">
          <canvas id="myChart6" width="100%" height="60" class="blockcont"></canvas>
          <div class="row smallmargin">
            <div class="col-xs-6">
              <canvas id="myChart14" width="100%" height="80" class="blockcont"></canvas>
            </div>
            <div class="col-xs-6">
              <canvas id="myChart8" width="100%" height="80" class="blockcont"></canvas>
            </div>

          </div>
          <div class="row smallmargin blockcont">
            <div class="col-xs-6">
              <canvas id="myChart7" width="100%" height="60" class="blockcont"></canvas>
            </div>
            <div class="col-xs-6">
              <canvas id="myChart9" width="100%" height="60" class="blockcont"></canvas>
            </div>
          </div>

          <div class="headnote forinvenlist">Inventory Data
            <div class="optionmenu"><label><input type="checkbox" class="condenseview">Condense View</label></div>
          </div>
          <ul class="itemlisttable samebglist itemlistsort invenlist supplylist">
            <li class="itemlisthead">
              <div>Supply</div>
              <div>Used vs Inventory</div>
              <div><span class="reset"> Reset</span></div>
            </li>
            <li>
              <div>Single prick</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="1888"></span></div>
            </li>
            <li>
              <div>Multi prick</div>
              <div><span class="used" data-number="463"></span><span class="inven" data-number="986"></span></div>
            </li>
            <li>
              <div>Testing syringe</div>
              <div><span class="used" data-number="363"></span><span class="inven" data-number="1056"></span></div>
            </li>
            <li>
              <div>Mixing syringe</div>
              <div><span class="used" data-number="189"></span><span class="inven" data-number="500"></span></div>
            </li>
            <li>
              <div>Treating syringe</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
          </ul>

          <ul class="itemlisttable samebglist itemlistsort invenlist supplyviallist">
            <li class="itemlisthead">
              <div>5ml Vial</div>
              <div>Used vs Inventory</div>
              <div><span class="reset"> Reset</span></div>
            </li>
            <li>
              <div>Pink vial</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="1888"></span></div>
            </li>
            <li>
              <div>Silver vial</div>
              <div><span class="used" data-number="463"></span><span class="inven" data-number="986"></span></div>
            </li>
            <li>
              <div>Green vial</div>
              <div><span class="used" data-number="363"></span><span class="inven" data-number="1056"></span></div>
            </li>
            <li>
              <div>Blue vial</div>
              <div><span class="used" data-number="189"></span><span class="inven" data-number="500"></span></div>
            </li>
            <li>
              <div>Yellow vial</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
            <li>
              <div>Red vial</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
          </ul>

          <ul class="itemlisttable samebglist itemlistsort invenlist supplyviallist">
            <li class="itemlisthead">
              <div>10ml Vial</div>
              <div>Used vs Inventory</div>
              <div><span class="reset"> Reset</span></div>
            </li>
            <li>
              <div>Pink vial</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="1888"></span></div>
            </li>
            <li>
              <div>Silver vial</div>
              <div><span class="used" data-number="463"></span><span class="inven" data-number="986"></span></div>
            </li>
            <li>
              <div>Green vial</div>
              <div><span class="used" data-number="363"></span><span class="inven" data-number="1056"></span></div>
            </li>
            <li>
              <div>Blue vial</div>
              <div><span class="used" data-number="189"></span><span class="inven" data-number="500"></span></div>
            </li>
            <li>
              <div>Yellow vial</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
            <li>
              <div>Red vial</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
          </ul>

          <ul class="itemlisttable samebglist itemlistsort invenlist supplybiolist">
            <li class="itemlisthead">
              <div>Biologic</div>
              <div>Used vs Inventory (mL)</div>
              <div class="listaction"><span class="sortalpha"> Sort</span><span class="reset"> Reset</span></div>
            </li>
            <li>
              <div>Omalizumab (Xolair™)</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="1888"></span></div>
            </li>
            <li>
              <div>Mepolizumab (Nucala™)</div>
              <div><span class="used" data-number="463"></span><span class="inven" data-number="986"></span></div>
            </li>
            <li>
              <div>Benralizumab (Fasenra™)</div>
              <div><span class="used" data-number="363"></span><span class="inven" data-number="1056"></span></div>
            </li>
            <li>
              <div>Reslizumab (Cinqair™)</div>
              <div><span class="used" data-number="189"></span><span class="inven" data-number="500"></span></div>
            </li>
            <li>
              <div>Dupilumab (Dupixent™)</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
            <li>
              <div>Anakinra (Kineret™)</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="356"></span></div>
            </li>
            <li>
              <div>Ecanllantide (Kalbitor™)</div>
              <div><span class="used" data-number="455"></span><span class="inven" data-number="789"></span></div>
            </li>
            <li>
              <div>C1 esterase inhibitor (Haggard™)</div>
              <div><span class="used" data-number="655"></span><span class="inven" data-number="1550"></span></div>
            </li>
            <li>
              <div>C1 esterase inhibitor (Cinryze™)</div>
              <div><span class="used" data-number="299"></span><span class="inven" data-number="279"></span></div>
            </li>
            <li>
              <div>C1 esterase inhibitor (Berinert™)</div>
              <div><span class="used" data-number="355"></span><span class="inven" data-number="831"></span></div>
            </li>
          </ul>

          <ul class="itemlisttable samebglist itemlistsort invenlist antigenlist">
            <li class="itemlisthead">
              <div>Antigen</div>
              <div>Used vs Inventory (mL)</div>
              <div class="listaction"><span class="sortalpha"> Sort</span><span class="reset"> Reset</span></div>
            </li>
            <li>
              <div>Antigen 1</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="1888"></span></div>
            </li>
            <li>
              <div>Antigen 2</div>
              <div><span class="used" data-number="463"></span><span class="inven" data-number="986"></span></div>
            </li>
            <li>
              <div>Antigen 3</div>
              <div><span class="used" data-number="363"></span><span class="inven" data-number="1056"></span></div>
            </li>
            <li>
              <div>Antigen 4</div>
              <div><span class="used" data-number="189"></span><span class="inven" data-number="500"></span></div>
            </li>
            <li>
              <div>Antigen 5</div>
              <div><span class="used" data-number="263"></span><span class="inven" data-number="256"></span></div>
            </li>
            <li>
              <div>Antigen 6</div>
              <div><span class="used" data-number="563"></span><span class="inven" data-number="356"></span></div>
            </li>
            <li>
              <div>Antigen 7</div>
              <div><span class="used" data-number="455"></span><span class="inven" data-number="789"></span></div>
            </li>
            <li>
              <div>Antigen 8</div>
              <div><span class="used" data-number="655"></span><span class="inven" data-number="1550"></span></div>
            </li>
            <li>
              <div>Antigen 9</div>
              <div><span class="used" data-number="299"></span><span class="inven" data-number="279"></span></div>
            </li>
            <li>
              <div>Antigen 10</div>
              <div><span class="used" data-number="355"></span><span class="inven" data-number="831"></span></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Statistic'
}
</script>

<style scoped>

</style>
